import { User, Session } from '@supabase/supabase-js';

import { createSlice } from '@reduxjs/toolkit';







// Redux state types
export interface ReduxSupabaseUSessionRootState {
    usession: {
        userSession: Session; // Replace with proper session type
        userData: User;
        isAuthenticated: boolean;
        isDemo: boolean;
        accessToken: string;
        refreshToken: string;
        tokenExpireTime: number;
    }

}

const initialState = {
    userSession: null, // Stores Cognito session information
    userData: null,
    isDemo: false,
    isAuthenticated: false, // Boolean flag for authentication status
    accessToken: null,
    refreshToken: null,
    tokenExpireTime: null
};

const usession = createSlice({
    name: 'usession-supabase',
    initialState,
    reducers: {
        setSession: (state, action) => {
            state.userSession = action.payload;
            state.isAuthenticated = true;
            state.accessToken = action.payload.access_token;
            state.refreshToken = action.payload.refresh_token;
            state.tokenExpireTime = action.payload.expires_at;
            // console.log("New Session Saved: ", action.payload);
        },
        setUserData: (state, action) => {
            state.userData = action.payload;
            state.isAuthenticated = true;
            // state.isDemo = action.payload.Settings?.isDemo ?? false;
            // console.log("New User Data Saved: ", action.payload);
        },
        clearSession: (state) => {
            state.userSession = null;
            state.userData = null;
            state.isDemo = false;
            state.isAuthenticated = false;
            state.accessToken = null;
            state.refreshToken = null;
            state.tokenExpireTime = null;
            console.log("Session Cleared");
        },
    },
});

export const { setSession, setUserData, clearSession } = usession.actions;
export default usession.reducer;
